import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ProdutoDocumentoService } from '../../../services/produto-documento.service';

@Component({
  selector: 'app-produto-documento-list',
  templateUrl: './produto-documento-list.component.html',
  styleUrls: ['./produto-documento-list.component.scss']
})
export class ProdutoDocumentoListComponent extends BaseListComponent<any> implements OnInit {

  list: any[];

  constructor(
    public activatedRoute: ActivatedRoute,
    public myService: ProdutoDocumentoService,
  ) {
    super();
  }

  ngOnInit() {
    this.loading();
    this.initLoadDataTable();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.findAll().subscribe((res) => {
        this.list = res;
        this.loaded();
      })
    );
  }

  confirmExcluir(id: number) {
    this.alertConfirmation(id).subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: number): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }
}
